export default __webpack_public_path__ + "static/1870_1880-485268cab021cebcdda2995d3a5bd92c.mp4";